import { observer } from 'mobx-react-lite'
import { useContext } from 'react'
import { Button } from 'shared/ui'

import { DoubleOptInPageContext } from 'pages/settings/pages/doubleOptIn/context/doubleOptInContext'
import styles from './styles.module.scss'

export const QuietHoursActions = observer(() => {
  const store = useContext(DoubleOptInPageContext)

  if (!store || !store.quietHoursStore || !store.quietHoursStore.isShowActions) return null

  const { saveSettings, handleCancel, loading } = store.quietHoursStore

  return (
    <div className={styles.actionsWrap}>
      <Button text={'Cancel'} disabled={loading} contained={'secondary'} onClick={handleCancel} />
      <Button text={'Save'} disabled={loading} loading={loading} onClick={saveSettings} />
    </div>
  )
})
